import * as React from 'react';
export var NotFound = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "shout text-center" },
        React.createElement("h2", null, "404"),
        React.createElement("h3", null, "Oh no! Page not found."),
        children));
};
//# sourceMappingURL=index.js.map